import { createFileRoute } from "@tanstack/react-router";
import DeductibilityPage from "@/features/public/pages/tools/deductibility";

export const Route = createFileRoute("/(public)/_public/tools/deductibility")({
  component: DeductibilityPage,
});
